import { REQUIRE_BATCH_PERSON_BIRTH_DATE } from "./batchPersonRegisterFlags";

export const FORMAT_ERROR = REQUIRE_BATCH_PERSON_BIRTH_DATE
  ? "Este arquivo não está no formato esperado. Use uma planilha CSV ou um arquivo JSON com CPF, nome, sexo, data de nascimento e telefone."
  : "Este arquivo não está no formato esperado. Use uma planilha CSV ou um arquivo JSON com CPF, nome, sexo e telefone.";

/** Modelo visível na tela e no download. Sexo: M/F ou masculino/feminino. Data: DD/MM/YYYY. */
export const BATCH_PERSON_CSV_TEMPLATE = `nome,cpf,sexo,dataNascimento,telefone
Maria Silva,123.456.789-00,feminino,01/01/1990,11999999999
João Santos,987.654.321-00,M,15/03/1985,21988887777
`;

export const BATCH_PERSON_JSON_TEMPLATE = `[
  {
    "nome": "Maria Silva",
    "cpf": "123.456.789-00",
    "sexo": "feminino",
    "dataNascimento": "01/01/1990",
    "telefone": "11999999999"
  },
  {
    "nome": "João Santos",
    "cpf": "987.654.321-00",
    "sexo": "M",
    "dataNascimento": "15/03/1985",
    "telefone": "21988887777"
  }
]
`;

const ALLOWED_EXTENSIONS = [".csv", ".json"];
const ALLOWED_MIMES = [
  "text/csv",
  "text/plain",
  "text/x-csv",
  "application/json",
  "application/vnd.ms-excel",
];

export function isAllowedBatchPersonFile(file: File): boolean {
  const name = file.name.toLowerCase();
  const hasExtension = ALLOWED_EXTENSIONS.some((ext) => name.endsWith(ext));
  if (!hasExtension) return false;
  const mime = (file.type || "").toLowerCase();
  if (!mime) return true;
  return ALLOWED_MIMES.includes(mime);
}
